export { default as RegisteredPaymentMethod } from './registered-payment-method'
